import axios from 'axios';
import { config } from './config';
import { DEFAULT_TENANT_ID } from '@/constants';
import { getActiveLanguage } from './utils';

/**
 * Axios instance configured for CMS API
 */
export const apiClient = axios.create({
  baseURL: `${config.apiBaseUrl}/api/${config.apiVersion}`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    "X-Tenant-Id": DEFAULT_TENANT_ID,
    'Accept-Language': getActiveLanguage() || 'en',
  },
});

// /**
//  * Request interceptor
//  */
// apiClient.interceptors.request.use(
//   (config) => {
//     // Add any auth tokens here if needed in the future
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

/**
 * Response interceptor
 */
apiClient.interceptors.response.use(
  (response) => {
    // Log successful responses in development
    if (import.meta.env.DEV) {
      console.log(`✅ API Success [${response.status}]:`, response.config.url);
    }
    return response;
  },
  (error) => {
    // Handle common errors
    if (error.response) {
      const { status, data } = error.response;

      // Log error for debugging with more detail
      console.error(`❌ API Error [${status}]:`, {
        url: error.config?.url,
        method: error.config?.method,
        data: data,
      });

      // Return formatted error
      return Promise.reject({
        status,
        message: data?.message || data?.error || data?.title || 'An error occurred',
        data: data,
      });
    } else if (error.request) {
      // Request was made but no response
      console.error('❌ Network Error:', {
        message: error.message,
        url: error.config?.url,
        baseURL: error.config?.baseURL,
      });
      return Promise.reject({
        status: 0,
        message: 'Network error. Please check your connection and ensure the backend API is running.',
        details: error.message,
      });
    } else {
      // Something else happened
      console.error('❌ Error:', error.message);
      return Promise.reject({
        status: 0,
        message: error.message || 'An unexpected error occurred',
      });
    }
  }
);

export default apiClient;
